// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TransactionHistory.css */

.table th,
.table td {
    vertical-align: middle;
    text-align: center;
}

.container {
    max-width: 1200px;
}

.table-responsive {
    margin-top: 20px;
}

.btn {
    min-width: 100px;
}


/* styles.css */

.button {
    background-color: #4E3B31;
    /* Green */
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 4px;
}

.button:hover {
    background-color: #45a049;
    /* Darker green */
}

.pagination {
    margin: 20px 0;
}

.page-item {
    margin: 0 5px;
}

.page-link {
    color: #4E3B31;
    border: 1px solid #dee2e6;
    padding: 8px 16px;
    border-radius: 5px;
    transition: all 0.3s ease;
}

.page-link:hover {
    background-color: #4E3B31;
    color: white;
}

.page-item.active .page-link {
    background-color: #4E3B31;
    border-color: #4E3B31;
    color: white;
}

.page-item.disabled .page-link {
    background-color: #f8f9fa;
    color: #6c757d;
    border-color: #dee2e6;
}

.page-item:not(.disabled) .page-link:hover {
    background-color: #4E3B31;
    border-color: #4E3B31;
    color: white;
}

/* table trasition */
.table-responsive {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.table th,
.table td {
    padding: 8px;
    border: 1px solid #ddd;
    white-space: nowrap;
}

/* Styles for mobile screens */
@media (max-width: 768px) {
    .table th:first-child {
        /* position: sticky; */
        left: 0;
        background-color: #4E3B31;
        color: white;
        z-index: 2;
    }

    .table td:first-child {
        /* position: sticky; */
        left: 0;
        background-color: white;
        z-index: 1;
    }
}

.table th:not(:first-child),
.table td:not(:first-child) {
    z-index: 0;
}

.table thead th {
    background-color: #4E3B31;
    color: white;
}

.pagination {
    flex-wrap: nowrap;
}

@media (max-width: 768px) {
    .pagination {
        font-size: 0.8rem;
    }
}


/* Pagination styles */
.pagination {
    flex-wrap: wrap;
}

.page-link {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/style/Transaction_his.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;;IAEI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,eAAe;;AAEf;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI;QACI,sBAAsB;QACtB,OAAO;QACP,yBAAyB;QACzB,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,OAAO;QACP,uBAAuB;QACvB,UAAU;IACd;AACJ;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;;AAGA,sBAAsB;AACtB;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* TransactionHistory.css */\r\n\r\n.table th,\r\n.table td {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\n.container {\r\n    max-width: 1200px;\r\n}\r\n\r\n.table-responsive {\r\n    margin-top: 20px;\r\n}\r\n\r\n.btn {\r\n    min-width: 100px;\r\n}\r\n\r\n\r\n/* styles.css */\r\n\r\n.button {\r\n    background-color: #4E3B31;\r\n    /* Green */\r\n    border: none;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    margin: 4px 2px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\n.button:hover {\r\n    background-color: #45a049;\r\n    /* Darker green */\r\n}\r\n\r\n.pagination {\r\n    margin: 20px 0;\r\n}\r\n\r\n.page-item {\r\n    margin: 0 5px;\r\n}\r\n\r\n.page-link {\r\n    color: #4E3B31;\r\n    border: 1px solid #dee2e6;\r\n    padding: 8px 16px;\r\n    border-radius: 5px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.page-link:hover {\r\n    background-color: #4E3B31;\r\n    color: white;\r\n}\r\n\r\n.page-item.active .page-link {\r\n    background-color: #4E3B31;\r\n    border-color: #4E3B31;\r\n    color: white;\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n    background-color: #f8f9fa;\r\n    color: #6c757d;\r\n    border-color: #dee2e6;\r\n}\r\n\r\n.page-item:not(.disabled) .page-link:hover {\r\n    background-color: #4E3B31;\r\n    border-color: #4E3B31;\r\n    color: white;\r\n}\r\n\r\n/* table trasition */\r\n.table-responsive {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    overflow-x: auto;\r\n    position: relative;\r\n}\r\n\r\n.table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n    padding: 8px;\r\n    border: 1px solid #ddd;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Styles for mobile screens */\r\n@media (max-width: 768px) {\r\n    .table th:first-child {\r\n        /* position: sticky; */\r\n        left: 0;\r\n        background-color: #4E3B31;\r\n        color: white;\r\n        z-index: 2;\r\n    }\r\n\r\n    .table td:first-child {\r\n        /* position: sticky; */\r\n        left: 0;\r\n        background-color: white;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.table th:not(:first-child),\r\n.table td:not(:first-child) {\r\n    z-index: 0;\r\n}\r\n\r\n.table thead th {\r\n    background-color: #4E3B31;\r\n    color: white;\r\n}\r\n\r\n.pagination {\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .pagination {\r\n        font-size: 0.8rem;\r\n    }\r\n}\r\n\r\n\r\n/* Pagination styles */\r\n.pagination {\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.page-link {\r\n    white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
